export const SURVEY_ARCHIVE_QP = 'archive';
